require('./bootstrap');
import navbar from './modules/navbar.js';
import fancybox from './modules/fancybox-images.js';
import accordion from './modules/accordion.js';
import animatedIcon from './modules/animated-icon.js';
import scroll from './modules/scroll.js';
import swiper from './modules/swiper.js';
import formValidation from './modules/form-validation.js';

(function ($) {
    $(document).ready(function () {
        navbar.init();
        scroll.init();

        if (document.querySelector('.accordion-item-title')) {
            accordion.init();
        }

        if (document.querySelector('.swiper, .feedback-carousel, .images-carousel, .images-carousel-small')) {
            swiper.init();
        }

        if (document.querySelector('[data-fancybox], [data-fancybox-single], [data-fancybox="gallery"]')) {
            fancybox.init();
        }

        if (document.querySelector('.animated-icon-path')) {
            animatedIcon.init();
        }

        if (document.querySelector('.js-validate-form, .js-form')) {
            formValidation.init();
        }

        // Select all elements with data-toggle="top" attribute
        document.querySelectorAll('[data-toggle="top"]').forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();

                // Smooth scroll to top
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });

                return false;
            });
        });

        const targetNode = document.body;
        const config = { childList: true, subtree: true };

        const callback = function(mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const img = document.querySelector('#qc-cmp2-persistent-link img');
                    if (img) {
                        img.alt = 'Personvern Icon';
                        observer.disconnect(); // Stop observing once we've made the change
                    }
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);


        // Check if grecaptcha is available
        if (typeof grecaptcha !== 'undefined') {
            // Get the site key and action from meta tags
            const siteKey = document.querySelector('meta[name="recaptcha-key"]').getAttribute('content');
            const actionName = document.querySelector('meta[name="recaptcha-action"]').getAttribute('content');

            if (siteKey && actionName) {
                grecaptcha.ready(function() {
                    grecaptcha.execute(siteKey, {action: actionName}).then(function(token) {
                        // Using vanilla JS instead of jQuery
                        const formValidationElements = document.querySelectorAll('.js-form-validation');
                        formValidationElements.forEach(function(element) {
                            element.value = token;
                        });

                        // If you're still using jQuery, use this instead:
                        // window.$('.js-form-validation').val(token);
                    });
                });
            }
        }

    });

})(window.jQuery);
